import { defineMessages } from 'react-intl';

export const locationResultsListsV2ExpandButtonMessages = defineMessages({
  expandButtonA11yLabel: {
    defaultMessage: 'Show all locations',
    description: 'Location Search | Expand button | A11y label',
  },
});
